import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { fetchDataAxios, updateData } from "../../hooks/services/services";

/* ─── SVG Icons ──────────────────────────────────────────── */
const MilestoneIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 3v18h18" /><path d="M18 9l-5 5-3-3-5 5" />
  </svg>
);
const RFPIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
    <polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);
const BellIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 01-3.46 0" />
  </svg>
);
const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const CheckAllIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const ChevronDownIcon = ({ open }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
    style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.25s ease" }}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
const ExternalLinkIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
    <polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);
const DescriptionIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" />
  </svg>
);
const FundsIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M16 8h-6a2 2 0 000 4h4a2 2 0 010 4H8" /><line x1="12" y1="6" x2="12" y2="8" /><line x1="12" y1="16" x2="12" y2="18" />
  </svg>
);
const UnitsIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
  </svg>
);
const NgoIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
  </svg>
);
const LocationIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
);
const EmailIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
  </svg>
);
const BudgetIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
  </svg>
);
const ActivitiesIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 11 12 14 22 4" /><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
  </svg>
);
const VillagesIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
  </svg>
);

/* ─── Helper ─────────────────────────────────────────────── */
function timeAgo(dateStr) {
  const now = new Date();
  const d = new Date(dateStr);
  const diff = Math.floor((now - d) / 1000);
  if (diff < 60) return "Just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString();
}

/* ─── Helper: detect if notification has any detail data ─── */
function hasDetailData(n) {
  return !!(n.description || n.budgetUtilized || n.noOfUnitsUtilized || n.ngoName || n.date || n.image);
}

/* ─── Main Drawer ────────────────────────────────────────── */
const NotificationDrawer = ({ isOpen, onClose, onUnreadChange }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedId, setExpandedId] = useState(null);
  const navigate = useNavigate();
  const drawerRef = useRef(null);
  const userEmail = localStorage.getItem("userEmail");

  const fetchNotifications = async () => {
    if (!userEmail) return;
    try {
      setLoading(true);
      const response = await fetchDataAxios(`/notifications/get?email=${userEmail}`);
      if (response && response.data) {
        setNotifications(response.data);
        const unread = response.data.some((n) => !n.isRead);
        onUnreadChange && onUnreadChange(unread);
      }
    } catch (err) {
      console.error("Error fetching notifications", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchNotifications();
      setExpandedId(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  /* close on outside click */
  useEffect(() => {
    const handleClick = (e) => {
      if (drawerRef.current && !drawerRef.current.contains(e.target) && isOpen) onClose();
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [isOpen, onClose]);

  const markRead = async (notification) => {
    if (!notification.isRead) {
      await updateData(`/notifications/mark-read/${notification.id}`, {});
      setNotifications((prev) =>
        prev.map((n) => (n.id === notification.id ? { ...n, isRead: true } : n))
      );
      const stillUnread = notifications.some((n) => n.id !== notification.id && !n.isRead);
      onUnreadChange && onUnreadChange(stillUnread);
    }
  };

  const handleNavigate = async (notification, e) => {
    e?.stopPropagation();
    try {
      await markRead(notification);
      onClose();
      if (notification.notificationType === "RFP") {
        navigate("/add-rfp-data", {
          state: { activity: notification.activityName, rfpDataId: notification.rfpDataId },
        });
      } else {
        navigate("/project-tracker/create-milestone", {
          state: {
            activity: notification.activityName,
            programId: notification.programId,
            milestoneId: notification.milestoneId,
          },
        });
      }
    } catch (err) {
      console.error("Error navigating from notification", err);
    }
  };

  const handleToggleExpand = async (notification, e) => {
    e?.stopPropagation();
    await markRead(notification);
    setExpandedId((prev) => (prev === notification.id ? null : notification.id));
  };

  const handleMarkAllRead = async () => {
    try {
      const unreadIds = notifications.filter((n) => !n.isRead).map((n) => n.id);
      await Promise.all(unreadIds.map((id) => updateData(`/notifications/mark-read/${id}`, {})));
      setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
      onUnreadChange && onUnreadChange(false);
    } catch (err) {
      console.error("Error marking all read", err);
    }
  };

  const unreadCount = notifications.filter((n) => !n.isRead).length;
  const unreadList = notifications.filter((n) => !n.isRead);
  const readList = notifications.filter((n) => n.isRead);

  return (
    <>
      {/* Overlay */}
      <div style={{
        position: "fixed", inset: 0,
        background: "rgba(10,18,40,0.38)",
        backdropFilter: "blur(3px)",
        zIndex: 1099,
        opacity: isOpen ? 1 : 0,
        pointerEvents: isOpen ? "auto" : "none",
        transition: "opacity 0.3s ease",
      }} />

      {/* Drawer */}
      <div
        ref={drawerRef}
        style={{
          position: "fixed", top: 0, right: 0,
          height: "100vh",
          width: "440px",
          maxWidth: "96vw",
          background: "#f4f6fb",
          boxShadow: "-10px 0 40px rgba(0,0,0,0.18)",
          zIndex: 1100,
          transform: isOpen ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.35s cubic-bezier(0.4,0,0.2,1)",
          display: "flex",
          flexDirection: "column",
          borderRadius: "16px 0 0 16px",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div style={{
          padding: "18px 20px 15px",
          background: "linear-gradient(135deg, #1a56db 0%, #0e3fa8 100%)",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          flexShrink: 0,
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "11px" }}>
            <div style={{
              width: "38px", height: "38px", borderRadius: "50%",
              background: "rgba(255,255,255,0.16)",
              display: "flex", alignItems: "center", justifyContent: "center", color: "#fff",
            }}>
              <BellIcon size={20} />
            </div>
            <div>
              <h6 style={{ margin: 0, color: "#fff", fontWeight: 700, fontSize: "16px", letterSpacing: "0.01em" }}>
                Notifications
              </h6>
              <span style={{ color: "rgba(255,255,255,0.72)", fontSize: "12px" }}>
                {unreadCount > 0 ? `${unreadCount} unread` : "All caught up!"}
              </span>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {notifications.length > 0 && (
              <button onClick={handleMarkAllRead} style={{
                background: "rgba(255,255,255,0.13)", border: "1px solid rgba(255,255,255,0.28)",
                borderRadius: "8px", color: "#fff", fontSize: "11px", padding: "5px 10px",
                cursor: "pointer", display: "flex", alignItems: "center", gap: "5px",
                whiteSpace: "nowrap",
              }}
                onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.22)"}
                onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.13)"}
              >
                <CheckAllIcon /> Clear all
              </button>
            )}
            <button onClick={onClose} style={{
              background: "rgba(255,255,255,0.13)", border: "none",
              borderRadius: "8px", width: "34px", height: "34px",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#fff", cursor: "pointer",
            }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.22)"}
              onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.13)"}
            >
              <CloseIcon />
            </button>
          </div>
        </div>

        {/* Body */}
        <div style={{ flex: 1, overflowY: "auto", padding: "10px 10px 6px" }}>
          {loading ? (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "200px", flexDirection: "column", gap: "12px" }}>
              <div className="spinner" style={{ width: "30px", height: "30px" }} />
              <span style={{ color: "#6b7280", fontSize: "13px" }}>Loading…</span>
            </div>
          ) : notifications.length === 0 ? (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "300px", gap: "14px", color: "#9ca3af" }}>
              <div style={{ width: "60px", height: "60px", borderRadius: "50%", background: "#e9ecf5", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <BellIcon size={26} />
              </div>
              <p style={{ margin: 0, fontSize: "14px", fontWeight: 600 }}>No notifications yet</p>
              <p style={{ margin: 0, fontSize: "12px" }}>You're all caught up!</p>
            </div>
          ) : (
            <>
              {unreadList.length > 0 && (
                <div style={{ padding: "4px 4px 6px", fontSize: "10.5px", fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.07em" }}>
                  New
                </div>
              )}
              {unreadList.map(n => (
                <NotificationCard
                  key={n.id}
                  notification={n}
                  expanded={expandedId === n.id}
                  onToggleExpand={handleToggleExpand}
                  onNavigate={handleNavigate}
                />
              ))}
              {readList.length > 0 && (
                <div style={{ padding: "10px 4px 6px", fontSize: "10.5px", fontWeight: 700, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.07em" }}>
                  Earlier
                </div>
              )}
              {readList.map(n => (
                <NotificationCard
                  key={n.id}
                  notification={n}
                  expanded={expandedId === n.id}
                  onToggleExpand={handleToggleExpand}
                  onNavigate={handleNavigate}
                />
              ))}
            </>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: "10px 16px", borderTop: "1px solid #dde2f0", flexShrink: 0, background: "#fff" }}>
          <p style={{ margin: 0, fontSize: "11px", color: "#9ca3af", textAlign: "center" }}>
            Click ↗ to open details · Click ⌄ to expand preview
          </p>
        </div>
      </div>
    </>
  );
};

/* ─── Single Notification Card ───────────────────────────── */
const NotificationCard = ({ notification, expanded, onToggleExpand, onNavigate }) => {
  const isRFP = notification.notificationType === "RFP";
  const title = notification.activityName || (isRFP ? "RFP Submission" : "Milestone Update");

  return (
    <div style={{
      background: "#fff",
      borderRadius: "12px",
      marginBottom: "8px",
      boxShadow: notification.isRead
        ? "0 1px 4px rgba(0,0,0,0.06)"
        : "0 2px 10px rgba(26,86,219,0.12)",
      border: notification.isRead ? "1px solid #e8eaf4" : "1px solid #bfcffa",
      overflow: "hidden",
      transition: "box-shadow 0.2s",
    }}>
      {/* Card top row */}
      <div style={{
        display: "flex", alignItems: "flex-start", gap: "12px",
        padding: "12px 12px 10px",
        cursor: "pointer",
        borderLeft: notification.isRead ? "3px solid transparent" : "3px solid #1a56db",
      }}
        onClick={(e) => onToggleExpand(notification, e)}
      >
        {/* Icon */}
        <div style={{
          width: "40px", height: "40px", borderRadius: "11px", flexShrink: 0,
          display: "flex", alignItems: "center", justifyContent: "center",
          background: isRFP
            ? "linear-gradient(135deg, #d1fae5, #a7f3d0)"
            : "linear-gradient(135deg, #dbeafe, #bfdbfe)",
          color: isRFP ? "#065f46" : "#1d4ed8",
          position: "relative",
        }}>
          {isRFP ? <RFPIcon size={18} /> : <MilestoneIcon size={18} />}
          {/* Small logo thumbnail if image exists */}
          {notification.image && !isRFP && (
            <img
              src={notification.image}
              alt="logo"
              style={{
                position: "absolute", bottom: -4, right: -4,
                width: "18px", height: "18px", borderRadius: "5px",
                objectFit: "cover", border: "1.5px solid #fff",
              }}
            />
          )}
        </div>

        {/* Content */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "3px" }}>
            <span style={{
              fontSize: "13.5px", fontWeight: notification.isRead ? 500 : 700,
              color: "#111827",
              overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
              maxWidth: "230px",
            }}>
              {title}
            </span>
            {!notification.isRead && (
              <span style={{
                width: "7px", height: "7px", borderRadius: "50%",
                background: "#1a56db", flexShrink: 0, display: "inline-block",
              }} />
            )}
          </div>
          {/* Quick summary chips */}
          <QuickSummary notification={notification} isRFP={isRFP} />
          <span style={{ fontSize: "11px", color: "#9ca3af", marginTop: "4px", display: "block" }}>
            {timeAgo(notification.createdAt)}
          </span>
        </div>

        {/* Right actions */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "6px", flexShrink: 0 }}>
          {/* Navigate button */}
          <button
            onClick={(e) => onNavigate(notification, e)}
            title="Open full record"
            style={{
              width: "28px", height: "28px", borderRadius: "7px",
              background: "linear-gradient(135deg, #1a56db, #0e3fa8)",
              border: "none", color: "#fff", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0,
              transition: "opacity 0.15s",
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = "0.8"}
            onMouseLeave={e => e.currentTarget.style.opacity = "1"}
          >
            <ExternalLinkIcon />
          </button>
          {/* Expand chevron */}
          <button
            onClick={(e) => onToggleExpand(notification, e)}
            title="Expand details"
            style={{
              width: "28px", height: "28px", borderRadius: "7px",
              background: "#f0f4ff", border: "1px solid #dde4ff",
              color: "#4b6bde", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0,
              transition: "background 0.15s",
            }}
            onMouseEnter={e => e.currentTarget.style.background = "#dde8ff"}
            onMouseLeave={e => e.currentTarget.style.background = "#f0f4ff"}
          >
            <ChevronDownIcon open={expanded} />
          </button>
        </div>
      </div>

      {/* Expanded panel */}
      {expanded && (
        <div style={{
          borderTop: "1px solid #eef1fb",
          padding: "12px 14px",
          background: "linear-gradient(160deg, #f8faff 0%, #eef3ff 100%)",
          animation: "nd-expand 0.22s ease",
        }}>
          {isRFP
            ? <RFPDetails notification={notification} onNavigate={onNavigate} />
            : <MilestoneDetails notification={notification} onNavigate={onNavigate} />
          }
        </div>
      )}
    </div>
  );
};

/* ─── Quick summary line ─────────────────────────────────── */
const QuickSummary = ({ notification, isRFP }) => {
  if (isRFP) {
    const items = [
      notification.ngoName && { icon: <NgoIcon />, label: notification.ngoName, color: "#065f46" },
      notification.budgetUtilized && { icon: <BudgetIcon />, label: `₹${notification.budgetUtilized}`, color: "#b45309" },
    ].filter(Boolean);
    if (!items.length) return (
      <p style={{ margin: "0 0 2px", fontSize: "12px", color: "#6b7280", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        New RFP/RFQ pending approval
      </p>
    );
    return (
      <div style={{ display: "flex", gap: "8px", flexWrap: "nowrap", overflow: "hidden", marginBottom: "2px" }}>
        {items.map((item, i) => (
          <span key={i} style={{ display: "flex", alignItems: "center", gap: "3px", fontSize: "11.5px", color: item.color, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "130px" }}>
            {item.icon} {item.label}
          </span>
        ))}
      </div>
    );
  }
  // Milestone — new milestone with no submitted data yet
  if (!hasDetailData(notification)) {
    return (
      <p style={{ margin: "0 0 2px", fontSize: "12px", color: "#9ca3af", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontStyle: "italic" }}>
        Awaiting data submission
      </p>
    );
  }
  // Milestone
  const items = [
    notification.description && { icon: <DescriptionIcon />, label: notification.description, color: "#1d4ed8" },
    notification.budgetUtilized && { icon: <FundsIcon />, label: `₹${notification.budgetUtilized}`, color: "#b45309" },
    notification.noOfUnitsUtilized && { icon: <UnitsIcon />, label: `${notification.noOfUnitsUtilized} units`, color: "#6d28d9" },
  ].filter(Boolean);
  if (!items.length) return (
    <p style={{ margin: "0 0 2px", fontSize: "12px", color: "#6b7280", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
      New milestone pending approval
    </p>
  );
  return (
    <div style={{ display: "flex", gap: "8px", flexWrap: "nowrap", overflow: "hidden", marginBottom: "2px" }}>
      {items.slice(0, 2).map((item, i) => (
        <span key={i} style={{ display: "flex", alignItems: "center", gap: "3px", fontSize: "11.5px", color: item.color, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "130px" }}>
          {item.icon} {item.label}
        </span>
      ))}
    </div>
  );
};

/* ─── Milestone Expanded Details ─────────────────────────── */
const MilestoneDetails = ({ notification, onNavigate }) => {
  const fields = [
    { icon: <DescriptionIcon />, label: "Description", value: notification.description },
    { icon: <FundsIcon />, label: "Funds Utilized", value: notification.budgetUtilized ? `₹${notification.budgetUtilized}` : null },
    { icon: <FundsIcon />, label: "Total Funds", value: notification.totalFunds ? `₹${notification.totalFunds}` : null },
    { icon: <UnitsIcon />, label: "Units Utilized", value: notification.noOfUnitsUtilized },
    { icon: <NgoIcon />, label: "NGO", value: notification.ngoName },
    { icon: <LocationIcon />, label: "Date", value: notification.date },
  ].filter(f => f.value);

  return (
    <div>
      {/* Image if available */}
      {notification.image && (
        <div style={{ marginBottom: "12px", display: "flex", alignItems: "center", gap: "10px" }}>
          <img
            src={notification.image}
            alt="Milestone"
            style={{ width: "52px", height: "52px", objectFit: "cover", borderRadius: "10px", border: "2px solid #dde4ff" }}
          />
          <div>
            <div style={{ fontSize: "12px", fontWeight: 700, color: "#1d4ed8" }}>{notification.activityName}</div>
            <div style={{ fontSize: "11px", color: "#6b7280" }}>Milestone Record</div>
          </div>
        </div>
      )}

      {fields.length > 0 ? (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
          {fields.map((f, i) => (
            <DetailChip key={i} icon={f.icon} label={f.label} value={f.value} />
          ))}
        </div>
      ) : (
        <div style={{
          padding: "14px", borderRadius: "10px",
          background: "linear-gradient(135deg, #eff6ff, #e0e9ff)",
          border: "1px dashed #bfcffa",
          textAlign: "center",
        }}>
          <div style={{ fontSize: "20px", marginBottom: "6px" }}>📋</div>
          <p style={{ margin: 0, fontSize: "12.5px", fontWeight: 600, color: "#1d4ed8" }}>No data submitted yet</p>
          <p style={{ margin: "4px 0 0", fontSize: "11.5px", color: "#6b7280" }}>Click below to open and fill milestone data</p>
        </div>
      )}

      <button
        onClick={(e) => onNavigate(notification, e)}
        style={{
          marginTop: "12px", width: "100%", padding: "9px",
          background: "linear-gradient(135deg, #1a56db, #0e3fa8)",
          color: "#fff", border: "none", borderRadius: "9px",
          fontSize: "12.5px", fontWeight: 600, cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center", gap: "6px",
          transition: "opacity 0.15s",
        }}
        onMouseEnter={e => e.currentTarget.style.opacity = "0.88"}
        onMouseLeave={e => e.currentTarget.style.opacity = "1"}
      >
        <ExternalLinkIcon /> Open Milestone Data
      </button>
    </div>
  );
};

/* ─── RFP Expanded Details ───────────────────────────────── */
const RFPDetails = ({ notification, onNavigate }) => {
  const fields = [
    { icon: <EmailIcon />, label: "Email", value: notification.createdBy },
    { icon: <NgoIcon />, label: "NGO Name", value: notification.ngoName },
    { icon: <BudgetIcon />, label: "Budget Proposed", value: notification.budgetUtilized ? `₹${notification.budgetUtilized}` : null },
    { icon: <ActivitiesIcon />, label: "Activity", value: notification.activityName },
    { icon: <DescriptionIcon />, label: "Objective", value: notification.description },
    { icon: <VillagesIcon />, label: "Villages", value: notification.noOfUnitsUtilized },
    { icon: <LocationIcon />, label: "Date", value: notification.date },
  ].filter(f => f.value);

  return (
    <div>
      {fields.length > 0 ? (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
          {fields.map((f, i) => (
            <DetailChip key={i} icon={f.icon} label={f.label} value={f.value} />
          ))}
        </div>
      ) : (
        <p style={{ margin: 0, fontSize: "12px", color: "#9ca3af" }}>No additional details available.</p>
      )}

      <button
        onClick={(e) => onNavigate(notification, e)}
        style={{
          marginTop: "12px", width: "100%", padding: "9px",
          background: "linear-gradient(135deg, #059669, #047857)",
          color: "#fff", border: "none", borderRadius: "9px",
          fontSize: "12.5px", fontWeight: 600, cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center", gap: "6px",
          transition: "opacity 0.15s",
        }}
        onMouseEnter={e => e.currentTarget.style.opacity = "0.88"}
        onMouseLeave={e => e.currentTarget.style.opacity = "1"}
      >
        <ExternalLinkIcon /> Open RFP Data
      </button>
    </div>
  );
};

/* ─── Reusable detail chip ───────────────────────────────── */
const DetailChip = ({ icon, label, value }) => (
  <div style={{
    background: "#fff", borderRadius: "8px", padding: "8px 10px",
    border: "1px solid #e4e8f6",
    display: "flex", flexDirection: "column", gap: "3px",
  }}>
    <div style={{ display: "flex", alignItems: "center", gap: "4px", color: "#6b7280" }}>
      {icon}
      <span style={{ fontSize: "10px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>{label}</span>
    </div>
    <span style={{ fontSize: "12.5px", fontWeight: 600, color: "#1f2937", wordBreak: "break-word" }}>
      {value}
    </span>
  </div>
);

/* Global styles injected once */
if (typeof document !== "undefined" && !document.getElementById("nd-styles")) {
  const style = document.createElement("style");
  style.id = "nd-styles";
  style.innerHTML = `
    @keyframes nd-expand {
      from { opacity: 0; transform: translateY(-6px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    #nd-drawer-body::-webkit-scrollbar { width: 5px; }
    #nd-drawer-body::-webkit-scrollbar-track { background: #f4f6fb; }
    #nd-drawer-body::-webkit-scrollbar-thumb { background: #c7d0eb; border-radius: 3px; }
  `;
  document.head.appendChild(style);
}

export default NotificationDrawer;
